import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { MSG_SHOW_ALERT, MSG_TYPE_CREATE_COMMENT_FAILURE, MSG_TYPE_DELETE_COMMENT_FAILURE, MSG_TYPE_DELETE_COMMENT_SUCCESS, MSG_TYPE_FETCH_COMMENTS_FAILURE, MSG_TYPE_FETCH_OWNERS_FAILURE, MSG_TYPE_FETCH_TEAMS_FAILURE, MSG_TYPE_UPDATE_COMMENT_FAILURE, MSG_TYPE_CREATE_TASK_FAILURE, MSG_TYPE_CREATE_TASK_SUCCESS, MSG_TYPE_UPDATE_TASK_SUCCESS, MSG_TYPE_UPDATE_TASK_FAILURE, MSG_TYPE_DELETE_TASK_SUCCESS, MSG_TYPE_DELETE_TASK_FAILURE, MSG_TYPE_FETCH_CALENDAR_TYPES_FAILURE, MSG_TYPE_FETCH_CAMPAIGNS_FAILURE, MSG_TYPE_FETCH_CALENDAR_EVENTS_FAILURE, MSG_TYPE_UPDATE_EVENT_FAILURE, MSG_TYPE_DELETE_EVENT_FAILURE, MSG_TYPE_SET_CAMPAIGN_COLOR_FAILURE, MSG_TYPE_UPDATE_EVENT_SUCCESS, MSG_TYPE_DELETE_EVENT_SUCCESS, MSG_TYPE_SET_CAMPAIGN_COLOR_SUCCESS, MSG_TYPE_RESOLVE_COMMENT_SUCCESS, MSG_TYPE_UNDO_RESOLVE_COMMENT, MSG_TYPE_UNRESOLVE_COMMENT_SUCCESS, MSG_TYPE_NOTIFICATION_SETTINGS_FAILURE } from '../constants/IFrameMessageTypes';
import { showErrorNotification, showRemovableNotification, showSuccessNotification } from '../utils/notifications';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function hasProp(obj, prop) {
  return prop in obj;
}
const failureMessageMap = {
  [MSG_TYPE_CREATE_COMMENT_FAILURE]: 'collaborationSidebar.notifications.failure.createComment',
  [MSG_TYPE_CREATE_TASK_FAILURE]: 'collaborationSidebar.notifications.failure.createTask',
  [MSG_TYPE_DELETE_TASK_FAILURE]: 'collaborationSidebar.notifications.failure.deleteTask',
  [MSG_TYPE_UPDATE_TASK_FAILURE]: 'collaborationSidebar.notifications.failure.updateTask',
  [MSG_TYPE_UPDATE_COMMENT_FAILURE]: 'collaborationSidebar.notifications.failure.updateComment',
  [MSG_TYPE_DELETE_COMMENT_FAILURE]: 'collaborationSidebar.notifications.failure.deleteComment',
  [MSG_TYPE_FETCH_COMMENTS_FAILURE]: 'collaborationSidebar.notifications.failure.fetchComments',
  [MSG_TYPE_FETCH_OWNERS_FAILURE]: 'collaborationSidebar.notifications.failure.fetchOwners',
  [MSG_TYPE_FETCH_TEAMS_FAILURE]: 'collaborationSidebar.notifications.failure.fetchTeams',
  [MSG_TYPE_FETCH_CALENDAR_TYPES_FAILURE]: 'collaborationSidebar.notifications.failure.fetchCalendarTypes',
  [MSG_TYPE_FETCH_CAMPAIGNS_FAILURE]: 'collaborationSidebar.notifications.failure.fetchCampaigns',
  [MSG_TYPE_FETCH_CALENDAR_EVENTS_FAILURE]: 'collaborationSidebar.notifications.failure.fetchCalendarEvents',
  [MSG_TYPE_UPDATE_EVENT_FAILURE]: 'collaborationSidebar.notifications.failure.updateEvent',
  [MSG_TYPE_DELETE_EVENT_FAILURE]: 'collaborationSidebar.notifications.failure.deleteEvent',
  [MSG_TYPE_SET_CAMPAIGN_COLOR_FAILURE]: 'collaborationSidebar.notifications.failure.setCampaignColor',
  [MSG_TYPE_NOTIFICATION_SETTINGS_FAILURE]: 'collaborationSidebar.notifications.failure.updateNotificationSettings'
};
const successMessageMap = {
  [MSG_TYPE_DELETE_COMMENT_SUCCESS]: 'collaborationSidebar.notifications.success.deleteComment',
  [MSG_TYPE_UNRESOLVE_COMMENT_SUCCESS]: 'collaborationSidebar.notifications.success.unresolveComment',
  [MSG_TYPE_CREATE_TASK_SUCCESS]: 'collaborationSidebar.notifications.success.createTask',
  [MSG_TYPE_DELETE_TASK_SUCCESS]: 'collaborationSidebar.notifications.success.deleteTask',
  [MSG_TYPE_UPDATE_TASK_SUCCESS]: 'collaborationSidebar.notifications.success.updateTask',
  [MSG_TYPE_UPDATE_EVENT_SUCCESS]: 'collaborationSidebar.notifications.success.updateEvent',
  [MSG_TYPE_DELETE_EVENT_SUCCESS]: 'collaborationSidebar.notifications.success.deleteEvent',
  [MSG_TYPE_SET_CAMPAIGN_COLOR_SUCCESS]: 'collaborationSidebar.notifications.success.setCampaignColor'
};
export default function useShowNotifications(iframeIsVisible, sendMessageRef) {
  "use memo";

  const $ = _c(5);
  let t0;
  if ($[0] !== iframeIsVisible) {
    t0 = (...t1) => {
      const args = t1;
      if (iframeIsVisible) {
        showErrorNotification(...args);
      }
    };
    $[0] = iframeIsVisible;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const maybeShowErrorNotification = t0;
  let t1;
  if ($[2] !== maybeShowErrorNotification || $[3] !== sendMessageRef) {
    t1 = t2 => {
      const {
        payload
      } = t2;
      if (!payload || !payload.type) {
        return;
      }
      if (payload.type === MSG_SHOW_ALERT) {
        if (payload.alertType === "success") {
          showSuccessNotification({
            message: payload.message
          });
        } else {
          maybeShowErrorNotification({
            message: payload.message,
            sticky: true
          });
        }
      } else {
        if (payload.type === MSG_TYPE_RESOLVE_COMMENT_SUCCESS) {
          const onRemove = showRemovableNotification({
            message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "collaborationSidebar.notifications.success.resolveComment_jsx",
              elements: {
                Button
              },
              options: {
                onUndo: event => {
                  event.stopPropagation();
                  if (sendMessageRef.current) {
                    sendMessageRef.current(MSG_TYPE_UNDO_RESOLVE_COMMENT, {
                      comment: payload.comment
                    });
                  }
                  onRemove();
                }
              }
            })
          });
        } else {
          if (payload.type.endsWith("_FAILURE") && hasProp(failureMessageMap, payload.type)) {
            const failureType = payload.type;
            maybeShowErrorNotification({
              message: I18n.text(failureMessageMap[failureType]),
              id: failureType,
              sticky: true
            });
          } else {
            if (payload.type.endsWith("_SUCCESS") && hasProp(successMessageMap, payload.type)) {
              const successType = payload.type;
              showSuccessNotification({
                message: I18n.text(successMessageMap[successType])
              });
            }
          }
        }
      }
    };
    $[2] = maybeShowErrorNotification;
    $[3] = sendMessageRef;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleMessage = t1;
  return handleMessage;
}